import React, { useEffect } from 'react'
import SearchForm from 'components/Search/SearchForm'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { GLOBAL_SEARCH_INITIAL_STATE, GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import type { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router'
import type { SupportedDestinations } from 'home/constants'
import { SUPPORTED_DESTINATION_IDS } from 'home/constants'
import { capitalise } from 'lib/string/stringUtils'
import Pane from 'components/Common/Pane'
import styled from 'styled-components'
import { rem } from 'polished'

const StyledPane = styled(Pane)`
  padding: ${rem(16)};
`

function DesktopSearch({ match }: RouteComponentProps<{ destination: SupportedDestinations }>) {
  const { globalHotelsSearchDispatch, globalHotelsSearchState } = useGlobalHotelsSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
  })

  const { destination } = match.params
  const destinationId = SUPPORTED_DESTINATION_IDS[destination]

  // sync search item
  useEffect(() => {
    const searchItem: App.SearchItem = {
      searchType: 'destination',
      value: destinationId,
      format: {
        mainText: capitalise(destination),
      },
    }
    globalHotelsSearchDispatch({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem })
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [])

  return (
    <StyledPane>
      <GlobalSearchContextProvider state={globalHotelsSearchState} dispatch={globalHotelsSearchDispatch}>
        <SearchForm submitOnApply />
      </GlobalSearchContextProvider>
    </StyledPane>
  )
}

export default withRouter(DesktopSearch)
